import { IsiIWSAssociatedViewContext } from "./IsiIwsAssociatedViewContext";

export enum HandlerType {
    Menu = 0,
    Da = 1,
    HMenu = 2
}

/**
 * Interface de l'objet de retour de notification du count.
 * 
 */
export interface IIsiDtoScreenListCount {
    nbPages?: number;
    nbRecord?: number;
    badgeLabel: string;
}

/***
 * Classe de gestion du count des DA/VT :
 * Permet de s'abonner à la demande de count d'une DA afin de ne le faire qu'une seule fois
 * au chargement d'un écran.
 */
export class IsiAssociatedViewCountProvider {

    /**
     * Tableau des observers par Da à notifier lorsque le count est obtenu
     */
    private _observers: Map<string, Map<HandlerType,(dto: IIsiDtoScreenListCount) => void>>

    /**
     * Constructeur
    */
    constructor() {
        this._observers = new Map<string, Map<HandlerType,(dto: IIsiDtoScreenListCount) => void>>();
    }

    /**
     * Définit la valeur du count d'une Da
     * @param count
     */
    public refreshCount(associatedViewContext: IsiIWSAssociatedViewContext) {
        if (associatedViewContext) {
            this._count(associatedViewContext);

            uiCore.associatedViewManager.updatedJoinCtrls(associatedViewContext).then(() => {
            associatedViewContext.refresh();
        });
        }
    }
    /**
     * Lance l'évaluation du count
     * @param associatedViewContext
     */
    private _count(associatedViewContext: IsiIWSAssociatedViewContext) {
        uiCore.gridManager.getCountNewGrid(associatedViewContext.id, uiCore.associatedViewManager.getLinkedCtrlsValues(associatedViewContext)).then((dto) => {
            if (dto.continue) {
                associatedViewContext.nbPages = dto.reponse.nbPages;
                associatedViewContext.nbRecord = dto.reponse.nbRecord;
                this._notify(associatedViewContext.id, this._buildDto(associatedViewContext))
            }
        });
    }
    /**
     * Lance la demande de comptage du nombre de lignes/pages
     * @param associatedViewContext
     * @param callBack
     */
    public getCount(associatedViewContext: IsiIWSAssociatedViewContext, refresh:boolean, handlerType: HandlerType, callBack: (dto: IIsiDtoScreenListCount) => void) {
        if (associatedViewContext) {
            this._registerObserver(associatedViewContext.id, handlerType,callBack);
            if (associatedViewContext.nbPages === null || refresh) {
                this._count(associatedViewContext);
            } else {
                if (callBack) {
                    callBack(this._buildDto(associatedViewContext));
                }
            }
        }
    }
    /**
     * Construit le dto pour la notification
     * @param associatedViewContext
     * @returns
     */
    private _buildDto(associatedViewContext: IsiIWSAssociatedViewContext): IIsiDtoScreenListCount {
        let badgeLabel: string;
        // Si on trouve un nombre Superieur ou Egale a 0 on le reprend, si il est supérieur à 100, on met 99+.
        if (associatedViewContext.nbRecord >= 0 && associatedViewContext.nbRecord < 100) {
            badgeLabel = "(" + associatedViewContext.nbRecord + ")";
        } else if (associatedViewContext.nbRecord >= 0 && associatedViewContext.nbRecord >= 100) {
            badgeLabel = "(99+)";
        }
    
        return {
            nbPages: associatedViewContext.nbPages,
            nbRecord: associatedViewContext.nbRecord,
            badgeLabel: badgeLabel
        } as IIsiDtoScreenListCount
    }
    /**
     * Notifie les observers.
     * @param screenList
     * @param dto
     */
    private _notify(screenList: string, dto: IIsiDtoScreenListCount) {
        if (this._observers.has(screenList)) {
            const handlers = this._observers.get(screenList);
            handlers.forEach((callback, key) => {
                callback(dto);
            });
        }
    }

    /**
     * Ajout un handler pour une écranliste donné s'il n'est pas déjà ajouté
     * @param screenList
     * @param callBack
     */
    private _registerObserver(screenList: string, handlerType: HandlerType, callBack: (dto: IIsiDtoScreenListCount) => void) {
    
        let handlers: Map<HandlerType, (dto: IIsiDtoScreenListCount) => void>;
        if (!this._observers.has(screenList)) {
            handlers = new Map<HandlerType, (dto: IIsiDtoScreenListCount) => void>();
            handlers.set(handlerType, callBack);
            this._observers.set(screenList, handlers);
        } else {
            handlers = this._observers.get(screenList);
        }
        if (!handlers.has(handlerType)) {
            handlers.set(handlerType,callBack);
        }

    }
}

